/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Self_Organize_HelpInputs */



/**
* | output |
* | --- |
* | "Pick 3 or 4 other registered players to seat with you. The app assigns seating." |
*
* @param {Self_Organize_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_help = /** @type {((inputs?: Self_Organize_HelpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_HelpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez 3 ou 4 autres joueurs inscrits pour s'asseoir avec vous. L'application attribue les placements.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija 3 o 4 jugadores inscritos más para sentarse con usted. La aplicación asigna los asientos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escolha 3 ou 4 outros jogadores inscritos para sentar com você. O aplicativo atribui os assentos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegliete altri 3 o 4 giocatori iscritti per sedersi con voi. L'app assegna i posti.")
	return /** @type {LocalizedString} */ ("Pick 3 or 4 other registered players to seat with you. The app assigns seating.")
});